import { BaseService } from "./BaseService";
import {
    CheckinSettingsResponse,
    CreateCheckinSettings,
    UpdateCheckinSettings,
} from "@/types/booking-checkin-settings";

class BookingCheckinSettingsService extends BaseService {
    private basePath = "/booking-checkins/settings";

    constructor() {
        super();
    }

    async getSettings(): Promise<CheckinSettingsResponse> {
        return this.get<CheckinSettingsResponse>(this.basePath);
    }

    async createSettings(
        data: CreateCheckinSettings
    ): Promise<CheckinSettingsResponse> {
        return this.post<CheckinSettingsResponse>(this.basePath, data);
    }

    async updateSettings(
        data: UpdateCheckinSettings
    ): Promise<CheckinSettingsResponse> {
        return this.patch<CheckinSettingsResponse>(this.basePath, data);
    }

    async getCheckinRecommendedServices(hotelId: string): Promise<any> {
        return this.get<any>(`/booking-checkins/hotels/${hotelId}/checkin-recommended-services`);
    }

    async updateCheckinRecommendedServices(hotelId: string, serviceIds: string[]): Promise<any> {
        return this.post<any>(`/booking-checkins/hotels/${hotelId}/checkin-recommended-services`, serviceIds);
    }

    async getCheckinFeaturedActivities(hotelId: string): Promise<any> {
        return this.get<any>(`/booking-checkins/hotels/${hotelId}/checkin-featured-activities`);
    }

    async updateCheckinFeaturedActivities(hotelId: string, serviceIds: string[]): Promise<any> {
        return this.post<any>(`/booking-checkins/hotels/${hotelId}/checkin-featured-activities`, serviceIds);
    }

    async getBookingCheckinUpsellServices(hotelId: string): Promise<any> {
        return this.get<any>(`/booking-checkins/hotels/${hotelId}/booking-checkin-upsell-services`);
    }

    async updateBookingCheckinUpsellServices(hotelId: string, serviceIds: string[]): Promise<any> {
        return this.post<any>(`/booking-checkins/hotels/${hotelId}/booking-checkin-upsell-services`, serviceIds);
    }
}

export const bookingCheckinSettingsService = new BookingCheckinSettingsService();
